/* angular:styles/component:scss;58143e27e242cb77396a2a7151e3ddf7aaae182309cbbf82fd99b2924e376623;D:\Techriff-Project\3amautocare\Autocare.Api\ClientApp\src\app\Formly\custom-types\custom-datepicker-min.type.ts */
::ng-deep .p-highlight {
  color: #D47500;
  background: #FFF1E0;
}
.p-error {
  color: #e24c4c;
  font-size: 13px;
  margin-top: 4px;
  font-weight: 500;
}
/*# sourceMappingURL=custom-datepicker-min.type-6RF7LUP7.css.map */
